import { useEffect, useState } from "react";
import { Container, Row, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FaBoxOpen } from "react-icons/fa";
import { FiltersProps } from "../../../../@types";
import { FlatCardObject } from "../../../../components/flat-card-object";
import { PaginationList } from "../../../../components/pagination";
import { IObjectResponse } from "../../../../models/IObjectResponse";
import { listMedia } from "../../../../services/media.service";
import { ListFilters } from "../../components/list-filters";
import { ListContent, NotFound } from "./styles";

export const MediaList = (): JSX.Element => {
	const { t: translation } = useTranslation();
	const [media, setMedia] = useState<IObjectResponse[]>([]);
	const [totalItens, setTotalItens] = useState(0);
	const [currentPage, setCurrentPage] = useState(1);
	const [loading, setLoading] = useState<boolean>(false);

	const [filters, setFilters] = useState<FiltersProps>({});

	const queryParams = new URLSearchParams(window.location.search);
	const search = queryParams.get("search");

	useEffect(() => {
		if (search) {
			setLoading(true);
			return;
		}

		setLoading(true);
		listMedia()
			.then((resp) => {
				setTotalItens(resp.count);
				setMedia(resp.results);
			})
			.catch(() => setLoading(false));
	}, []);

	const handleFilters = (event?: any) => {
		setFilters({ ...event, page: 1 });
	};

	const handlePageChange = (event?: any) => {
		setFilters({ ...filters, page: event });
	};

	useEffect(() => {
		if (
			Object.keys(filters).length > 0 &&
			(filters.q !== "" ||
				filters.page ||
				(filters.knowledge && filters.knowledge.length !== 0) ||
				(filters.modalities && filters.modalities.length !== 0) ||
				(filters.categories && filters.categories !== ""))
		) {
			setLoading(true);
			listMedia(filters)
				.then((resp) => {
					setTotalItens(resp.count);
					setMedia(resp.results);
					if (filters && filters.page) {
						setCurrentPage(filters.page);
					}
					setLoading(false);
				})
				.catch(() => setLoading(false));
		}
	}, [filters]);

	return (
		<Container fluid>
			<Row className="mb-2">
				<ListFilters
					handleFilter={handleFilters}
					hasModalityFilter
				></ListFilters>
			</Row>
			<Row>
				<span>
					<b>{totalItens}</b> {translation("filters.resultFound")}
				</span>
			</Row>
			<Row className="mt-4 mb-3">
				{loading ? (
					<NotFound>
						<Spinner
							animation="border"
							variant="primary"
							style={{
								width: "2rem",
								height: "2rem",
								borderWidth: "0.25em",
								borderRightColor: "transparent",
							}}
						/>
					</NotFound>
				) : (
					<>
						{media.length === 0 ? (
							<NotFound>
								<FaBoxOpen className="iconNotFound"></FaBoxOpen>
								<div>Nenhum resultado encontrado</div>
							</NotFound>
						) : (
							<ListContent>
								{!!media.length &&
									media.map((i) => (
										<FlatCardObject
											key={i.id}
											object={i}
										/>
									))}
							</ListContent>
						)}
					</>
				)}
			</Row>
			<Row>
				{!loading && media.length > 0 ? (
					<PaginationList
						currentPage={currentPage}
						totalItems={totalItens}
						onPageChange={handlePageChange}
					></PaginationList>
				) : (
					<></>
				)}
			</Row>
		</Container>
	);
};
